<div
    [ngClass]="[faceItem.selected && !recapMode ? 'windowFaceList windowFaceListSelected' : 'windowFaceList']"
    (click)="openInfo(screenItem.i)"
    id="{{ faceItem.id }}"
>
    <!-- Bouton Select - Dans le recap Panier -->
    <article
        *ngIf="recapMode"
        class="selectedDiv fromList test test2"
        (click)="clickScreenFromMap(faceItem, screenItem)"
    >
        <span class="material-icons">delete</span>
        <span>Retirer</span>
    </article>

    <!-- Layer 'écran non disponible' -->
    <div
        class="layerOn"
        *ngIf="(!screenItem.ic || (faceItem.nf != null && faceItem.nf.length != 0)) && !faceItem.selected"
    >
        <span>Ecran non disponible</span>
    </div>

    <div *ngIf="faceItem.nf != null && faceItem.nf.length != 0" class="nfReasonsContainer">
        <span
            >Indisponible du {{ faceItem.nf[0].di | date: 'dd/MM/yyyy' }} au
            {{ faceItem.nf[0].da | date: 'dd/MM/yyyy' }}</span
        >
        <span *ngIf="faceItem.nf[1] != null"
            >Indisponible du {{ faceItem.nf[1].di | date: 'dd/MM/yyyy' }} au
            {{ faceItem.nf[1].da | date: 'dd/MM/yyyy' }}</span
        >
        <span *ngIf="faceItem.nf.length > 2">Voir plus</span>
    </div>

    @if (!screenItem.ic && (faceItem.nf == null || faceItem.nf.length <= 0)) {
        <div class="nfReasonsContainer">
            <span>Activité interdite</span>
        </div>
    }

    <!-- Bouton Select - Dans la map -->
    <article
        *ngIf="
            !recapMode &&
            (screenItem.ic || faceItem.selected) &&
            (faceItem.nf == null || faceItem.nf.length == 0 || faceItem.selected)
        "
        [ngClass]="[faceItem.selected ? 'selectedDiv' : 'selectedDiv unselect']"
        (click)="clickScreenFromMap(faceItem, screenItem)"
    >
        <span *ngIf="!faceItem.selected" class="material-icons" style="font-weight: normal !important">add</span>
        <span *ngIf="faceItem.selected" class="material-icons">verified</span>
        <span *ngIf="faceItem.selected">Ajouté</span>
        <span *ngIf="!faceItem.selected">Ajouter</span>
    </article>

    <!-- Prix de l'écran -->
    @if (faceItem?.pd) {
        <article class="priceDiv" ngClass="{{ screenItem.sp == 14 ? 'indoor' : 'outdoor' }}">
            <!-- <span class="material-icons-outlined">sell</span> -->
            <span>{{ faceItem?.pd | currency: 'EUR' : 'symbol' : undefined : 'fr' }} / jour</span>
        </article>
    }

    <!-- Bouton pour aggrandir l'image -->
    @if (screenItem.ic && (faceItem.nf == null || faceItem.nf.length <= 0)) {
        <button (click)="openImgDetail()" class="imgDetailBtn" mat-icon-button matTooltip="Aggrandir l'image">
            <mat-icon style="color: white">aspect_ratio</mat-icon>
        </button>
    }

    <img
        [ngClass]="[
            !screenItem.ic || (faceItem && faceItem.nf != null && faceItem.nf.length != 0)
                ? 'screenImg inactiveScreen'
                : 'screenImg',
        ]"
        alt="Miniature de l'écran"
        *ngIf="faceItem.ts && faceItem.ts != null && faceItem.ts != ''"
        src="{{ baseUrl }}/file/getFile/{{ faceItem.ts }}/{{ faceItem.ts }}"
    />
    <div
        [ngClass]="[
            !screenItem.ic || (faceItem && faceItem.nf != null && faceItem.nf.length != 0)
                ? 'screenTypeContainerDiv inactiveScreen'
                : 'screenTypeContainerDiv',
        ]"
    >
        <div class="screenTypeContainer">
            <mat-icon
                *ngIf="screenItem.sp == 14"
                style="height: 40px; margin-left: 10px"
                alt="Ecran indoor"
                class="screenTypeImg"
                svgIcon="store-indoor"
            ></mat-icon>
            <mat-icon
                *ngIf="screenItem.sp != 14"
                style="height: 40px"
                alt="Ecran outdoor"
                class="screenTypeImg"
                svgIcon="store-outdoor"
            ></mat-icon>

            <!-- Distance et position de l'écran -->
            <div class="screenTypeInfo">
                <p style="font-family: ubuntu, Arial, Helvetica, sans-serif">
                    <span class="outdoor" *ngIf="screenItem.sp != 14">Ecran Géant bord de route</span>
                    <span class="indoor" *ngIf="screenItem.sp == 14">Ecran Intérieur</span>
                    <span class="locationInfo" style="display: inline-block; margin-left: 5px">
                        à {{ screenItem.di }} Km</span
                    >
                </p>
                <p class="locationInfo">
                    <span *ngIf="faceItem.vs == 0">Vue Gauche</span>
                    <span *ngIf="faceItem.vs == 1">Vue Droite</span>
                    <ng-container *ngIf="faceItem.dc != null">
                        <span *ngIf="faceItem.dc == 0" style="display: inline-block; margin-left: 5px"
                            ><span class="material-icons">arrow_right_alt</span> Entrée de ville</span
                        >
                        <span *ngIf="faceItem.dc == 1" style="display: inline-block; margin-left: 5px"
                            ><span class="material-icons">arrow_right_alt</span> Sortie de ville</span
                        >
                    </ng-container>
                </p>
            </div>
        </div>

        <!-- Adresse de l'écran -->
        <p class="locationName">
            {{ screenItem.ad }}<br />
            {{ screenItem.zc }} {{ screenItem.cn }}
            <!-- <span class="technicalName">{{ screenItem.sc }}</span> -->
        </p>

        @if (faceItem.pw && faceItem.ph) {
            <p class="sizeInfo" matTooltip="Résolution de l'écran:  {{ faceItem.pw }}px * {{ faceItem.ph }}px">
                <span class="material-icons">aspect_ratio</span>
                {{ faceItem.pw }}*{{ faceItem.ph }} px - {{ screen$.getAspectRatio(faceItem.pw, faceItem.ph) }}
            </p>
        }
        <!-- ODVs de la face -->
        <div class="odvContainer">
            <div class="odvTitle">
                <p *ngIf="faceItem?.o?.t">
                    <mat-icon matTooltip="ODV" class="material-icons">people</mat-icon> {{ faceItem?.o?.t }} Audiences
                    <ng-container *ngIf="!hasDateSelected"> /jour </ng-container>
                </p>
                <a
                    *ngIf="!mini"
                    style="cursor: pointer"
                    (click)="showOdvChart()"
                    matTooltip="Voir le graphique des ODV"
                >
                    Voir {{ isOdvChartDisplayed ? '-' : '+' }}
                </a>
            </div>

            <div class="chart" *ngIf="!mini && isOdvChartDisplayed">
                <canvas
                    height="75px"
                    baseChart
                    [options]="chartOptions"
                    [data]="chartData"
                    [type]="'bar'"
                    [labels]="labels"
                >
                </canvas>
            </div>
        </div>

        <span class="technicalName">{{ screenItem.sc }}</span>
        <!-- MARK: Bouton fermer si mode mini -->
        <button *ngIf="mini" id="closeBtn" mat-stroked-button (click)="close()">Fermer</button>
    </div>
</div>
